import { flushSync } from "react-dom";
import { Button, Select, Space, Typography } from "antd";
import React, { MouseEvent, useEffect, useMemo, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router";
import { getMasterRepairshopList } from "../../../../apis/master";
import { postChangeRepairshopAccount } from "../../../../apis/master/Select";
import useShop from "../../../../hooks/useShop";
import useUsers from "../../../../hooks/useUsers";
import { setSpecial } from "../../../../redux/slices/SpecialSlice";
import { PATH } from "../../../../routes/constants/path";
import { alertSuccess } from "../../../../shared/utils";
import { getDecodeToken } from "../../../../shared/utils/Token";
import color from "../../../../theme/color";
import { SolidPerson } from "../../Icon";
import { ArrowChevronDown } from "../../Icon/Arrow";
import { IconForm } from "../../Icon/index.styled";
import { sendSignOut } from "../apis";
import { FlexSpace } from "./index.styled";

const UserInfo: React.FC = () => {
  const { signOut, getAdminInfo, signIn, getAid, getUserID } = useUsers();
  const user = getAdminInfo();

  const nav = useNavigate();
  const { shop, setShop } = useShop();

  const info = getDecodeToken();

  const { data, mutate } = useMutation(
    "postMasterReparship",
    postChangeRepairshopAccount
  );

  const { data: list } = useQuery("repairShopList", getMasterRepairshopList, {
    enabled: info?.isMaster,
  });

  const signOutMutation = useMutation(sendSignOut, {
    onSuccess: () => {
      signOut();
      setSpecial("");
      nav(PATH.LOGIN);
    },
    onError: () => {
      signOut();
      setSpecial("");
      nav(PATH.LOGIN);
    },
  });

  const onSignOut = (e: MouseEvent) => {
    e.preventDefault();
    signOutMutation.mutate();
  };

  const handleChange = (value: string) => {
    const target = list?.find((row) => row.id === +value);
    if (target) {
      const name =
        getUserID() === +value
          ? `${target.displayName} [마스터]`
          : target.displayName;
      alertSuccess(`${name} 로 접속하셨습니다.`);
    }

    // @TODO 토큰 재갱신하기
    mutate(+value);
    setSearch("");
  };

  useEffect(() => {
    if (info) {
      if (info.selectedRepairShop) {
        mutate(info.selectedRepairShop);
      } else if (info.isMaster) {
        mutate(user?.id as number);
      }
    }
  }, []);

  useEffect(() => {
    if (data && data.accessToken) {
      signIn(user, data.accessToken);

      const info = getDecodeToken();
      setShop((info?.selectedRepairShop as number).toString());
    }
  }, [data]);

  const options = useMemo(() => {
    const repairs =
      list?.map((item) => ({
        label: item.displayName,
        value: item.id?.toString(),
      })) || [];
    return [...repairs];
  }, [list]);

  const [search, setSearch] = useState("");

  return (
    <Space
      size={16}
      align="center"
      style={{ display: "inline-flex", justifyContent: "end" }}
    >
      <FlexSpace size={6} align="center">
        <IconForm
          component={SolidPerson}
          style={{
            fontSize: 24,
            background: color.gray8,
            borderRadius: 100,
            overflow: "hidden",
            width: 32,
            height: 32,
            paddingTop: 8,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          color={color.gray6}
        />
        {info?.isMaster ? (
          <Select
            bordered={false}
            options={options}
            value={search || shop}
            style={{ minWidth: 150 }}
            onChange={handleChange}
            showSearch
            onSearch={(value) => {
              flushSync(() => {
                setSearch(value);
              });
            }}
            optionFilterProp="label"
            filterOption={(input, option) =>
              (option?.label as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            suffixIcon={
              <IconForm
                component={ArrowChevronDown}
                color={color.gray4}
                style={{ fontSize: 10 }}
              />
            }
          />
        ) : (
          <Typography.Text
            style={{ margin: 0, fontWeight: 700 }}
          >{`${getAid()} 님`}</Typography.Text>
        )}
      </FlexSpace>

      <Button type="default" ghost onClick={onSignOut}>
        로그아웃
      </Button>
    </Space>
  );
};

export default UserInfo;
